// extracted by mini-css-extract-plugin
export default {"mainLayout":"main_mainLayout__xZrai","column":"main_column__hrhbb","box":"main_box__zP42E","list":"main_list__xNGzr","chat":"main_chat__GQosl","create":"main_create__tqo7f"};